import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Input } from './ui/input';
import { Button } from './ui/button';
import { Search } from 'lucide-react';

const SearchSystem = ({ placeholder = "Ne arıyorsunuz? Örn: E-ticaret sitesi, logo tasarımı, mobil uygulama..." }) => {
  const navigate = useNavigate();
  const [query, setQuery] = useState('');

  const handleSearch = (e) => {
    e.preventDefault();
    if (query.trim()) {
      navigate(`/arama?q=${encodeURIComponent(query.trim())}`);
    }
  };

  return (
    <form onSubmit={handleSearch} className="w-full">
      <div className="relative flex gap-2">
        <div className="relative flex-1">
          <Input
            type="text"
            placeholder=""
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            className="w-full color-white h-14 pl-12 pr-4 text-lg border-2 border-white/20 bg-white/10 backdrop-blur text-white focus:border-yellow-400 focus:ring-2 focus:ring-yellow-400"
          />
          {/* Animated Placeholder */}
          {!query && (
            <div className="absolute left-12 top-1/2 -translate-y-1/2 pointer-events-none overflow-hidden w-[calc(100%-4rem)]">
              <div className="flex animate-slide-placeholder text-white/70 text-lg whitespace-nowrap" style={{ width: '200%' }}>
                <span className="inline-block flex-shrink-0 mr-8">{placeholder}</span>
                <span className="inline-block flex-shrink-0">{placeholder}</span>
              </div>
            </div>
          )}
          <Search className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-300" />
        </div>
        <Button
          type="submit"
          size="lg"
          variant="outline"
          className="h-14 px-8 border-2 border-white text-white hover:bg-white hover:text-gray-900 font-bold"
        >
          Ara
        </Button>
      </div>
    </form>
  );
};

export default SearchSystem;
